var map = {
	"./AMZN.png": 1230,
	"./APPLE.png": 518,
	"./AUDUSD.png": 5166,
	"./Brent (Brent Crude Oil).png": 9258,
	"./CAC.png": 25,
	"./CADUSD.png": 4160,
	"./CHFUSD.png": 3211,
	"./CNYUSD.png": 8608,
	"./CORN.png": 6514,
	"./Coffee - (Coffee Cash Contract).png": 4483,
	"./Cotton (Cotton Cash Contract).png": 8268,
	"./DAX.png": 7821,
	"./DJI.png": 9721,
	"./EURUSD.png": 5864,
	"./FTSE100.png": 9153,
	"./GBPUSD.png": 1375,
	"./GOOGL (Alphabet Inc (Google) Class A).png": 6591,
	"./HSI.png": 1478,
	"./INTC (Intel Corporation).png": 8813,
	"./JPN225.png": 3069,
	"./JPYUSD.png": 6973,
	"./META (Meta Platforms).png": 507,
	"./MSFT (Microsoft Corp.).png": 5137,
	"./MU (Micron Technology).png": 2659,
	"./NASDAQ100.png": 9531,
	"./NGAS (Natural gas).png": 2348,
	"./NZDUSD.png": 1504,
	"./Nikkei225.png": 9370,
	"./Nvidia-1.png": 8067,
	"./Nvidia.png": 4601,
	"./SP500.png": 1640,
	"./US2000.png": 3538,
	"./USDBRL.png": 1968,
	"./USDPLN.png": 1934,
	"./Wheat (Wheat Cash Contract).png": 5834,
	"./XAGUSD (Silver).png": 7494,
	"./XAUUSD.png": 446,
	"./cooper.png": 8262,
	"./f (Ford Motor Company).png": 3688,
	"./none.png": 3818
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7958;